module["exports"] = ["gmail.com", "yahoo.com", "posta.ge"];